module.exports = __webpack_public_path__ + "img/horizontal_6_7_pp123_3009.a5676c1f.png";